<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-header class="p-4">
        <b-form v-on:submit.prevent="onSubmit">
          <h1>{{this.$route.name}}</h1>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label-align-sm="right" label-cols-sm="3" label="Nº do Formulário: ">
                <b-input-group>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nº do sistema cliente"
                    v-model="questionario.id"
                    autocomplete="num"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group label-cols-sm="1" label-align-sm="right" label="Título: ">
                <b-input-group>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nº do sistema cliente"
                    v-model="questionario.titulo"
                    autocomplete="num"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-header>
      <b-card-body>
        <b-col sm="12" md="6">
          <b-form-group label="Enviar por:">
            <b-form-radio-group
              id="radio-slots"
              v-model="form.tipoEnvio"
              :disabled="reencaminhar"
              :options="options"
              name="radio-options-slots"
              :state="chkState('tipoEnvio')"
            />
          </b-form-group>
        </b-col>
      </b-card-body>
      <b-card-body v-if="form.tipoEnvio === 'email'">
        <b-row v-if="!reencaminhar">
          <b-col sm="12" md="11">
            <b-form-group label-cols-sm="2" label="E-mails a adicionar: ">
              <b-input-group>
                <b-form-input
                  type="text"
                  class="form-control"
                  v-model="emailsAdicionar"
                  :disabled="reencaminhar"
                  :state="chkState('emails')"
                />
                <b-form-invalid-feedback
                  id="input1LiveFeedback3"
                >Deve ser informado ao menos um e-mail.</b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="!reencaminhar">
          <b-col offset-md="3" sm="12" md="3">
            <b-button
              block
              variant="primary"
              class="emailActions"
              :disabled="reencaminhar"
              v-on:click="adicionarEmails"
            >Adicionar</b-button>
          </b-col>
          <b-col sm="12" md="3">
            <b-button
              block
              class="emailActions"
              variant="primary"
              :disabled="reencaminhar"
              v-b-modal.modal-import
            >Importar E-mails</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-table
              striped
              responsive
              small
              bordered
              :items="form.emails"
              filter
              :current-page="pagina"
              :fields="fields"
              per-page="10"
              :show-empty="true"
              empty-text="Não há e-mails informados..."
              empty-filtered-text="Nenhum resultado encontrado!"
            >

            <template v-slot:cell(actions)="row">
              <b-button size="sm" :disabled="reencaminhar" title="Remover e-mail" @click="removerEmail(row.item, row.index)" class="mr-1">
                <i class="fa fa-times"/>
              </b-button>
            </template>

            </b-table>
            <b-pagination
              v-model="pagina"
              :total-rows="form.emails.length"
              per-page="10"
              size="sm"
              align="right"
              ></b-pagination>

          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="11">
            <b-form-group label-cols-sm="2" label="Assunto: ">
              <b-input-group>
                <b-form-input
                  type="text"
                  class="form-control"
                  v-model="form.assunto"
                  :state="chkState('assunto')"
                />
                <b-form-invalid-feedback
                  id="input1LiveFeedback3"
                >Deve ser informado um assunto para o e-mail.</b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="11">
            <b-form-group label-cols-sm="2" label="Mensagem: ">
              <b-input-group>
                <b-form-textarea
                  id="textarea-auto-height"
                  rows="3"
                  max-rows="8"
                  v-model="form.mensagem"
                  :state="chkState('mensagem')"
                ></b-form-textarea>
                <b-form-invalid-feedback
                  id="input1LiveFeedback3"
                >Deve ser informado uma mensagem para o e-mail.</b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="11">
            <b-form-group label-cols-sm="2" label="Organização: ">
              <b-input-group>
                <b-form-input
                  :disabled="reencaminhar"
                  type="text"
                  class="form-control"
                  v-model="form.organizacao"
                />
              </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      </b-card-body>
      <b-card-body v-if="form.tipoEnvio === 'link'">
        <b-row>
          <b-col sm="12">
            <b-form-group label="Link: ">
              <b-input-group>
                <b-form-input
                  type="text"
                  :disabled="true"
                  class="form-control"
                  v-model="linkKey"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading && form.tipoEnvio !== 'link'" md="3">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span>{{ reencaminhar ? 'Reencaminhar' : encaminhar ? 'Encaminhar' : 'Publicar'}}</span>
            </b-button>
          </b-col>
          <b-col v-if="!loading && form.tipoEnvio === 'link'" md="3">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="copiarLink">
              Copiar
            </b-button>
          </b-col>
          <b-col v-if="loading" md="3">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>
              {{ reencaminhar ? 'Reencaminhando...' : encaminhar ? 'Encaminhando...' : 'Publicando...'}}
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button
              block
              variant="secondary"
              :disabled="disable_buttons"
              @click="voltar()"
            >
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;
              <span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
    <b-modal
      size="lg"
      title="Importar E-mails"
      id="modal-import"
      ok-title="Importar"
      cancel-title="Cancelar"
      @ok="importarEmails()"
    >
      <b-col sm="12" md="12">
        <vue-csv-import
          v-model="arquivoEmails"
          :headers="false"
          :map-fields="['e-mail']"
          buttonClass="btn btn-primary"
        >
          <template slot="error">Arquivo Inválido</template>
          <template slot="thead">
            <tr>
              <th>Campos</th>
              <th>Coluna</th>
            </tr>
          </template>
          <template slot="next" slot-scope="{load}">
            <button class="btn btn-primary" @click.prevent="load">Carregar</button>
          </template>
        </vue-csv-import>
      </b-col>
      <template v-slot:modal-footer="{ ok, cancel }">
        <span>
          <b-button
            v-b-tooltip.hover
            title="Download do modelo de arquivo para importar e-mails"
            block
            variant="outline-primary"
          >
            <downloadCsv :data="json_data">
              <span>Download Modelo</span>
            </downloadCsv>
          </b-button>
        </span>
        <b-button variant="info" v-on:click="ok()">Importar</b-button>
        <b-button variant="danger" v-on:click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import {
  required,
  requiredIf
} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import VueClipboard from 'vue-clipboard2'
import JsonCSV from 'vue-json-csv'
import SessionStorage from '@/services/session-storage'
import {VueCsvImportPlugin} from "vue-csv-import";

Vue.use(VueCsvImportPlugin)
   
Vue.use(VueClipboard)
VueClipboard.config.autoSetContainer = true
miniToastr.init()

export default {
  name: 'Publicar',
  components: {
    VueSelect,
    Multiselect,
    downloadCsv: JsonCSV,
    VueClipboard
  },
  mixins: [validationMixin],
  validations: {
    form: {
      tipoEnvio: {required},
      emails: {
        required: requiredIf(function (data) {
          return data.emails.length < 1 && data.tipoEnvio === 'email'
        })
      },
      assunto: {
        required: requiredIf(function (data) {
          return !data.assunto && data.tipoEnvio === 'email'
        })
      },
      mensagem: {
        required: requiredIf(function (data) {
          return !data.mensagem && data.tipoEnvio === 'email'
        })
      }
    }
  },
  created () {

      let usuario = SessionStorage.get('usuario')

      this.buscaUsuarioIntegracao(usuario)
     
      if (!usuario) {
        this.$router.push('/login')
      }
      this.$store.dispatch('atualizarPermissoes')

    if (!this.can('questionario.publish')) {
      this.$router.push('/')
    }

    if (this.$route.matched.some(({ name }) => name === 'Reencaminhar Resposta')) {
      this.$store.dispatch('getEnvio', this.$route.params.id)
    } else {
      this.$store.dispatch('getQuestionario', this.$route.params.id)
      this.$store.dispatch('getLink')
    }
  },
  data () {
    return {
      loading: false,
      questionarioReenvio: [],
      form: {
        tipoEnvio: '',
        emails: [],
        assunto: '',
        mensagem: '',
        organizacao: '',
        idQuestionario: '',
        link: ''
      },
      options: [
        { text: 'E-mail', value: 'email' },
        { text: 'Link', value: 'link' }
      ],
      usuarioIntegracao: [],
      sistemaIntegracao: [],
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false,
      arquivoEmails: [],
      emailsAdicionar: '',
      pagina: 1,
      fields: [
        { key: 'email',
          label: 'Para'},
        { key: 'actions',
          label: 'Ações',
          thStyle: {
            width: '10%',
            'text-align': 'center'
          },
          tdClass: 'text-center'
        }
      ],
      json_data: [
        {
          'e-mail': 'example@netmail.com'
        },
        {
          'e-mail': 'exempla@dotmail.com'
        }
      ]
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    questionario () {
      if (this.$route.matched.some(({ name }) => name === 'Reencaminhar Resposta')) {
        return this.questionarioReenvio
      } else {
        return this.$store.state.questionario.questionarioEditar
      }
    },
    linkKey () {
      return this.$store.state.envio.link['link'] + this.$store.state.envio.link['token']
    },
    envio () {
      return this.$store.state.envio.envio
    },
    reencaminhar () {
      return this.$route.matched.some(
        ({ name }) => name === 'Reencaminhar Resposta'
      )
    },
    encaminhar () {
      return this.$route.matched.some(
        ({ name }) => name === 'Encaminhar Formulário'
      )
    }
  },
  watch: {
    'envio': function () {
      this.form.tipoEnvio = 'email'
      this.form.emails.push({'email': this.envio.email})
      this.form.organizacao = this.envio.organizacao
      this.questionarioReenvio = this.envio.questionario
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    copiarLink () {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja continuar? Ao copiar o link o formulário será publicado!', {
          okTitle: 'Publicar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            this.publicarLink()
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    publicarLink () {
      this.$copyText(this.linkKey).then(function (e) {
        miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
        miniToastr.success('Link copiado com sucesso!', 'Sucesso!', 7000)
      }, function (e) {
        miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
        miniToastr.error('Erro ao copiar! Por favor copie o link atravéz do campo!', 'Alerta!', 5000)
      })

      let form = this.form
      let data = {
        questionario_id: this.questionario.id,
        tipo_envio: form.tipoEnvio,
        link: this.linkKey,
        token: this.$store.state.envio.link['token'],
        questionario: this.questionario.titulo,
        sistema_id: this.questionario.sistema_cliente_id
      }

      this.loading = true

      this.publicar(data)
    },
    importarEmails () {
      this.arquivoEmails.shift()

      this.arquivoEmails.forEach(element => {
        if (!this.form.emails.some(item => item['email'].toLowerCase() === element['e-mail'].toLowerCase())) {
          this.form.emails.push({'email': element['e-mail']})
        } else {
          miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
          miniToastr.error('E-mail: "' + element['e-mail'] + '" já está presente na lista!', 'Alerta!', 5000)
        }
      })
    },
    adicionarEmails () {
      if (this.emailsAdicionar !== '') {
        let array = this.emailsAdicionar.split(/\s*;\s*|\s*,\s*/)

        array.forEach(element => {
          if (!this.form.emails.some(item => item['email'].toLowerCase() === element.toLowerCase())) {
            this.form.emails.push({'email': element})
          } else {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error('E-mail: "' + element + '" já está presente na lista!', 'Alerta', 5000)
          }
        })

        this.emailsAdicionar = ''
      }
    },
    removerEmail (item, index) {
      this.form.emails.splice(index, 1)
    },
    uploadArquivo (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()
      reader.onload = (evento) => {
        this.arquivoEmails = evento.target.result
      }

      reader.readAsDataURL(arquivo[0])
    },
    publicarEmail () {
      let form = this.form
      let data = {
        id: this.envio.id ? this.envio.id : null,
        questionario_id: this.questionario.id,
        tipo_envio: form.tipoEnvio,
        emails: form.emails,
        assunto: form.assunto,
        mensagem: form.mensagem,
        organizacao: form.organizacao,
        questionario: this.questionario.titulo,
        sistema_id: this.questionario.sistema_cliente_id
      }

      this.loading = true

      this.publicar(data)
    },
    buscaUsuarioIntegracao(user_id){     
      Vue.http.get('api/usuario/' + user_id).then(response => {      
        this.usuarioIntegracao = response.data.data[0]
        if(this.usuarioIntegracao.sistema_cliente_id){
            Vue.http.get('api/sistema/' + this.usuarioIntegracao.sistema_cliente_id).then(response => {
              this.sistemaIntegracao = response.data.data[0]             
            })
        }
      })
    },
    publicar (data) {
      Vue.http
        .post('api/envio/publicar', data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            if (this.sistemaIntegracao.redirect_cadastro) {
                window.location.href = this.sistemaIntegracao.url_cliente
            }
            if (this.reencaminhar) {
              this.$router.push('/formulario/respostas/' + this.questionario.id)
            } else {
              this.$router.push({ path: '/formularios' })
            }
          }
        })
        .catch((e) => {
          console.log('Servidor está fora! ' + e)
        })

      this.loading = false
    },
    confirmar () {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja continuar?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            this.publicarEmail()
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      if (!this.visualizacao) {
        const field = this.$v.form[val]
        if (!field.$model && !this.salvarForm) {
          return null
        }

        return !field.$dirty || !field.$invalid
      }
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    voltar () {
      if (this.sistemaIntegracao.redirect_cadastro) {
        window.location.href = this.sistemaIntegracao.url_cliente
      }
      if (this.reencaminhar) {
        this.$router.push('/formulario/respostas/' + this.questionario.id)
      } else {
        this.$router.push('/sistemas')
      }
    }
  }
}
</script>

<style scope>
.emailActions {
  margin-bottom: 10px
}

.text-center {
  text-align: center
}

</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/cliente/questionarios/PublicarQuestionarios.vue